<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-24 11:37:54
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-24 15:47:53
 -->
<template>
  <div :style="svgStyle">
    <svg :style="svgStyle">
      <path :d="pathString" :stroke="trailColor" :stroke-width="trailWidth" :fill-opacity="0"/>
      <path :d="pathString" stroke-linecap="round" :stroke="strokeColor" :stroke-width="strokeWidth" fill-opacity="0" :style="pathStyle"/>
    </svg>
    <div class="vux-circle-content"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: 'processCircle',
  props: {
    strokeWidth: {// 线条宽度
      type: Number,
      default: 1,
    },
    strokeColor: {// 线条颜色
      type: String,
      default: '#3FC7FA',
    },
    trailWidth: { // 背景线条宽度
      type: Number,
      default: 1,
    },
    trailColor: { // 背景线条宽度
      type: String,
      default: '#D9D9D9',
    },
    percent: { // 进度百分比
      type: Number,
      default: 0,
    },
    rd: { // 圆大小半径
      type: Number,
      default: 60,
    },
  },
  computed: {
    svgStyle () {
      return {
        'width': `${2 * this.rd}px`,
        'height': `${2 * this.rd}px`,
        'position': 'relative',
        'margin': '5% auto',
      }
    },
    radius () { // 外圆圆半径
      return this.rd - this.strokeWidth / 2
    },
    pathString () {
      return `M ${this.rd},${this.rd} m 0,-${this.radius}
      a ${this.radius},${this.radius} 0 1 1 0,${2 * this.radius}
      a ${this.radius},${this.radius} 0 1 1 0,-${2 * this.radius}`
    },
    len () { // Math.PI 圆周率 3.141592653589793 len是圆的周长
      return Math.PI * 2 * this.radius
    },
    pathStyle () {
      return {
        'stroke-dasharray': `${this.len}px ${this.len}px`,
        'stroke-dashoffset': `${((100 - this.percent) / 100 * this.len)}px`, // 动画占圆周长百分比
        'transition': 'stroke-dashoffset 1s ease', // 2s代表动画时间
      }
    },
  },
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .vux-circle-content {
    width: 65%;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 55%;
    transform: translate(-50%,-50%);
    color: #fff;
    font-size: 1.8vh;
    .label {
      margin-bottom: 5%;
    }
    .value {
      font-weight: bold;
      font-size: 2vh;
    }
  }
</style>
